import getNextClue from "../utils/getNextClue";
import getPreviousClue from "../utils/getPreviousClue";
import scrollScreen from "../utils/scrollScreen";
import setSubFocus from "../utils/setSubFocus";
import { allPlayableCells, clearLetters, isPlayable, revealCells, scoreCrossword, wordCells } from "../rules";
import { iState } from "./interfaces";

export const INITIAL_STATE: iState = {
  GameTemplate: {
    matrix: [[
      {
        numero: 0,
        letra: "a",
        palavra_horizontal: 0,
        palavra_vertical: 0,
        palavra_1: 0,
        palavra_2: 0,
        visivel: true,
        destaque: true,
        casa_morta: false
      }
    ]],
    chaves: {
      horizontal: {
        "0": [
          {
            id: 0,
            chave: "Carregando...",
            palavras_id: 0,
            tamanho: 4,
            indice: 1,
            palavras: {
              id: 0,
              direcao: 0,
              x: 0,
              y: 0,
              fim: 3
            }
          }
        ]
      },
      vertical: {
        "1": [
          {
            id: 0,
            chave: "Carregando...",
            palavras_id: 575383,
            tamanho: 4,
            indice: 1,
            palavras: {
              id: 575383,
              direcao: 0,
              x: 0,
              y: 0,
              fim: 3
            }
          }
        ],

      }
    },
  },
  GameState: {
    currentClueNumber: "0",
    currentClueText: "Loading",
    orientation: "horizontal",
    maxScore: 0,
    cluesInfos: {
      firstClueNumberHorizontal: 0,
      firstClueNumberVertical: 0,
      lastClueNumberHorizontal: 0,
      lastClueNumberVertical: 0,
    },
    finished: false,
    completed: false,
    score: 0,
    time: 0,
    scrollElementRef: undefined,
    keyboardUP: false,
    focusedHouse: { column: 0, row: 0 },
    savedGame: {
      id: 0,
      passatempos_id: 0,
      users_id: 0,
      cache: {
        tempo: 0,
        pontuacao: 0,
        matrix: [[
          {
            numero: 0,
            letra: "a",
            palavraHorizontal: 0,
            palavraVertical: 0,
          }
        ]]
      }
    },
    houseStates: [
      [{
        isSubFocused: false,
        isCorrect: '',
        isFocused: false,
        scored: false,
        isHighlight: false,
        palavraHorizontal: 0,
        palavraVertical: 0,
      }]],
    rowsCoords: [],
  }

}


export default function reducer(state: iState, action: any): iState {
  switch (action.type) {
    case 'CLUE_HOUSE_CLICK': {
      const newState = { ...state };
      const { GameState, GameTemplate } = newState;
      const { house } = action.payload;
      newState.GameState.keyboardUP = !newState.GameState.keyboardUP;
      //check with palavra_1 exist
      if (house.palavra_1 !== -1) {
        //verify is house clue is horizontal ou vertical
        if (house.palavra_1.direcao === 0) {
          //horizontal
          //check with word is  fillable
          const { fim, x, y: row } = GameTemplate.chaves.horizontal[house.palavra_1.id.toString()][0].palavras;
          for (var i = x; i < (fim + x); i++) {
            const { letra } = GameState.savedGame.cache.matrix[row][i];

            if (letra === "" || letra === null || letra === undefined) {
              //now get the end of current clue with palavra id
              GameState.currentClueNumber = house.palavra_1.id.toString();
              GameState.currentClueText = GameTemplate.chaves.horizontal[GameState.currentClueNumber][0].chave;
              var subFocus = setSubFocus({
                selectedClue: GameState.currentClueNumber,
                orientation: "horizontal",
                focusedHouse: { column: i, row: house.palavra_1.y },
                houseStates: GameState.houseStates
              });
              GameState.orientation = "horizontal";
              GameState.focusedHouse = subFocus.focusedHouse;
              return newState;
            }
          }
        } else {
          //vertical
          //check with word is  fillable
          const { fim, x: column, y } = GameTemplate.chaves.vertical[house.palavra_1.id.toString()][0].palavras;
          for (var i = y; i < (fim + y); i++) {
            const { letra } = GameState.savedGame.cache.matrix[i][column];
            if (letra === "" || letra === null || letra === undefined) {
              //now get the end of current clue with palavra id
              GameState.currentClueNumber = house.palavra_1.id.toString();
              GameState.currentClueText = GameTemplate.chaves.vertical[GameState.currentClueNumber][0].chave;
              var subFocus = setSubFocus({
                selectedClue: GameState.currentClueNumber,
                orientation: "vertical",
                focusedHouse: { column: house.palavra_1.x, row: i },
                houseStates: GameState.houseStates
              });
              GameState.orientation = "vertical";
              GameState.focusedHouse = subFocus.focusedHouse;
              return newState;
            }
          }
        }
      }
      if (house.palavra_2 !== -1) {
        //check with word is  fillable
        if (house.palavra_2.direcao === 0) {
          //horizontal
          //check with word is  fillable
          const { fim, x, y: row } = GameTemplate.chaves.horizontal[house.palavra_2.id.toString()][0].palavras;
          for (var i = x; i < (fim + x); i++) {
            const { letra } = GameState.savedGame.cache.matrix[row][i];
            if (letra === "" || letra === null || letra === undefined) {
              //now get the end of current clue with palavra id
              GameState.currentClueNumber = house.palavra_2.id.toString();
              GameState.currentClueText = GameTemplate.chaves.horizontal[GameState.currentClueNumber][0].chave;
              var subFocus = setSubFocus({
                selectedClue: GameState.currentClueNumber,
                orientation: "horizontal",
                focusedHouse: { column: i, row: house.palavra_2.y },
                houseStates: GameState.houseStates
              });
              GameState.orientation = "horizontal";
              GameState.focusedHouse = subFocus.focusedHouse;
              return newState;
            }
          }
        } else {
          //vertical
          //check with word is  fillable
          const { fim, x: column, y } = GameTemplate.chaves.vertical[house.palavra_2.id.toString()][0].palavras;
          for (var i = y; i < (fim + y); i++) {
            const { letra } = GameState.savedGame.cache.matrix[i][column];
            if (letra === "" || letra === null || letra === undefined) {
              //now get the end of current clue with palavra id
              GameState.currentClueNumber = house.palavra_2.id.toString();
              GameState.currentClueText = GameTemplate.chaves.vertical[GameState.currentClueNumber][0].chave;
              var subFocus = setSubFocus({
                selectedClue: GameState.currentClueNumber,
                orientation: "vertical",
                focusedHouse: { column: house.palavra_2.x, row: i },
                houseStates: GameState.houseStates
              });
              GameState.orientation = "vertical";
              GameState.focusedHouse = subFocus.focusedHouse;
              return newState;
            }
          }
        }
      }


      return newState;
    }
    case 'SET_CURRENT_HOUSE': {
      const newState = { ...state };
      const { GameState, GameTemplate } = newState;
      const { column, row } = action.payload;
      newState.GameState.keyboardUP = !newState.GameState.keyboardUP;

      if (GameState.orientation === "horizontal") {
        if (GameTemplate.matrix[row][column].palavra_horizontal === -1) {
          //If the click was in a house where there is no horizontal
          GameState.currentClueNumber = GameTemplate.matrix[row][column].palavra_vertical.toString();
          GameState.currentClueText = GameTemplate.chaves.vertical[GameTemplate.matrix[row][column].palavra_vertical.toString()][0].chave;
          var subFocus = setSubFocus({
            selectedClue: GameState.currentClueNumber,
            orientation: "vertical",
            focusedHouse: { column, row },
            houseStates: GameState.houseStates
          });
          GameState.orientation = "vertical";
          GameState.focusedHouse = subFocus.focusedHouse;
          //scrollScreen(newState.GameState);
          return newState;
        }
        GameState.currentClueNumber = GameTemplate.matrix[row][column].palavra_horizontal.toString();
        GameState.currentClueText = GameTemplate.chaves.horizontal[GameTemplate.matrix[row][column].palavra_horizontal.toString()][0].chave;
        var subFocus = setSubFocus({
          selectedClue: GameState.currentClueNumber,
          orientation: "horizontal",
          focusedHouse: { column, row },
          houseStates: GameState.houseStates
        });
        GameState.houseStates = subFocus.houseStates;
        GameState.focusedHouse = subFocus.focusedHouse;
      } else {
        if (GameTemplate.matrix[row][column].palavra_vertical === -1) {
          //If the click was in a house where there is no vertical
          GameState.currentClueNumber = GameTemplate.matrix[row][column].palavra_horizontal.toString();
          GameState.currentClueText = GameTemplate.chaves.horizontal[GameTemplate.matrix[row][column].palavra_horizontal.toString()][0].chave;
          var subFocus = setSubFocus({
            selectedClue: GameState.currentClueNumber,
            orientation: "horizontal",
            focusedHouse: { column, row },
            houseStates: GameState.houseStates
          });
          GameState.orientation = "horizontal";
          GameState.houseStates = subFocus.houseStates;
          GameState.focusedHouse = subFocus.focusedHouse;
          //scrollScreen(newState.GameState);
          return newState;
        }
        GameState.currentClueNumber = GameTemplate.matrix[row][column].palavra_vertical.toString();
        GameState.currentClueText = GameTemplate.chaves.vertical[GameTemplate.matrix[row][column].palavra_vertical.toString()][0].chave;
        var subFocus = setSubFocus({
          selectedClue: GameState.currentClueNumber,
          orientation: "vertical",
          focusedHouse: { column, row },
          houseStates: GameState.houseStates
        });
        GameState.houseStates = subFocus.houseStates;
        GameState.focusedHouse = subFocus.focusedHouse;
      }
      //scrollScreen(newState.GameState);
      return newState;

    }
    case 'CHANGE_ORIENTATION': {
      const newState = { ...state };
      const { GameState, GameTemplate } = newState;
      const { column, row } = action.payload;
      newState.GameState.keyboardUP = !newState.GameState.keyboardUP;


      if (GameState.orientation === "horizontal") {
        if (GameTemplate.matrix[row][column].palavra_vertical === -1) {
          return newState;
        }
        GameState.currentClueNumber = GameTemplate.matrix[row][column].palavra_vertical.toString();
        GameState.currentClueText = GameTemplate.chaves.vertical[GameTemplate.matrix[row][column].palavra_vertical.toString()][0].chave;
        var subFocus = setSubFocus({
          selectedClue: GameState.currentClueNumber,
          orientation: "vertical",
          focusedHouse: { column, row },
          houseStates: GameState.houseStates
        });
        GameState.orientation = "vertical";

        GameState.houseStates = subFocus.houseStates;
        GameState.focusedHouse = subFocus.focusedHouse;
      } else {
        if (GameTemplate.matrix[row][column].palavra_horizontal === -1) {
          return newState;
        }
        GameState.currentClueNumber = GameTemplate.matrix[row][column].palavra_horizontal.toString();
        GameState.currentClueText = GameTemplate.chaves.horizontal[GameTemplate.matrix[row][column].palavra_horizontal.toString()][0].chave;
        var subFocus = setSubFocus({
          selectedClue: GameState.currentClueNumber,
          orientation: "horizontal",
          focusedHouse: { column, row },
          houseStates: GameState.houseStates
        });
        GameState.orientation = "horizontal";

        GameState.houseStates = subFocus.houseStates;
        GameState.focusedHouse = subFocus.focusedHouse;
      }
      return newState;

    }
    case 'INSERT': {
      var newState = { ...state };
      const currentLetter = action.payload.value.replace(new RegExp('[ÁÀÂÃ]', 'gi'), 'a')
        .replace(new RegExp('[ÉÈÊ]', 'gi'), 'e')
        .replace(new RegExp('[ÍÌÎ]', 'gi'), 'i')
        .replace(new RegExp('[ÓÒÔÕ]', 'gi'), 'o')
        .replace(new RegExp('[ÚÙÛ]', 'gi'), 'u')
        .toUpperCase()

      if (newState.GameState.focusedHouse.row > (newState.GameTemplate.matrix.length - 1)) {
        newState.GameState.focusedHouse.row = (newState.GameTemplate.matrix.length - 1)
        newState.GameState.focusedHouse.column = (newState.GameTemplate.matrix[0].length - 1)
        getNextClue(newState.GameState, newState.GameTemplate);
        //scrollScreen(newState.GameState);
        return newState;
      } else if (newState.GameState.focusedHouse.column > (newState.GameTemplate.matrix[0].length - 1)) {
        newState.GameState.focusedHouse.row = (newState.GameTemplate.matrix.length - 1)
        newState.GameState.focusedHouse.column = (newState.GameTemplate.matrix[0].length - 1)
        getNextClue(newState.GameState, newState.GameTemplate);
        //scrollScreen(newState.GameState);
        return newState;
      }

      const focusedCell = newState.GameState.savedGame.cache.matrix[newState.GameState.focusedHouse.row][newState.GameState.focusedHouse.column];
      // Casa revelada fica com a letra do gabarito (não pontua e não muda).
      if (!focusedCell.revelada && !newState.GameState.finished) {
        focusedCell.letra = currentLetter;
      }
      newState.GameState.score = scoreCrossword(newState.GameTemplate, newState.GameState.savedGame.cache.matrix);
      //turn off focused house
      newState.GameState.houseStates[newState.GameState.focusedHouse.row][newState.GameState.focusedHouse.column].isFocused = false;
      if (newState.GameState.orientation === "horizontal") {
        //check if the word is in the end or it possible to focus the next houseStates
        newState.GameState.focusedHouse.column++;

        const { fim, x } = newState.GameTemplate.chaves.horizontal[newState.GameState.currentClueNumber][0].palavras;
        if (newState.GameState.focusedHouse.column > (fim + x)) {
          getNextClue(newState.GameState, newState.GameTemplate);
          //scrollScreen(newState.GameState);
          return newState;

        } else {
          //check if the house is already filled
          const { letra } = newState?.GameState?.savedGame?.cache?.matrix[newState.GameState.focusedHouse.row][newState.GameState.focusedHouse.column];
          if (letra === "" || letra === null || letra === undefined) {
            newState.GameState.houseStates[newState.GameState.focusedHouse.row][newState.GameState.focusedHouse.column].isFocused = true;
          }
          else {
            //iteract the rest o line to find the next house
            for (let i = newState.GameState.focusedHouse.column; i < (fim + x); i++) {
              if (newState.GameState.savedGame.cache.matrix[newState.GameState.focusedHouse.row][i].letra === null || newState.GameState.savedGame.cache.matrix[newState.GameState.focusedHouse.row][i].letra === undefined || newState.GameState.savedGame.cache.matrix[newState.GameState.focusedHouse.row][i].letra === "") {
                newState.GameState.focusedHouse.column = i;
                newState.GameState.houseStates[newState.GameState.focusedHouse.row][newState.GameState.focusedHouse.column].isFocused = true;
                return newState;
              }
            }
            getNextClue(newState.GameState, newState.GameTemplate);
            ////scrollScreen(newState.GameState);

          }

        }

      } else {
        newState.GameState.focusedHouse.row++;
        const { fim, y } = newState.GameTemplate.chaves.vertical[newState.GameState.currentClueNumber][0].palavras;

        if (newState.GameState.focusedHouse.row > (fim + y)) {
          getNextClue(newState.GameState, newState.GameTemplate);
          //scrollScreen(newState.GameState);
          return newState;
        } else {
          //check if the house is already filled
          const { letra } = newState.GameState.savedGame.cache.matrix[newState.GameState.focusedHouse.row][newState.GameState.focusedHouse.column]
          if (letra === "" || letra === null || letra === undefined) {
            newState.GameState.houseStates[newState.GameState.focusedHouse.row][newState.GameState.focusedHouse.column].isFocused = true;
          }
          else {
            //iteract the rest o line to find the next house
            for (let i = newState.GameState.focusedHouse.row; i < (fim + y); i++) {
              if (newState.GameState.savedGame.cache.matrix[i][newState.GameState.focusedHouse.column].letra === null || newState.GameState.savedGame.cache.matrix[i][newState.GameState.focusedHouse.column].letra === undefined || newState.GameState.savedGame.cache.matrix[i][newState.GameState.focusedHouse.column].letra === "") {
                newState.GameState.focusedHouse.row = i;
                newState.GameState.houseStates[newState.GameState.focusedHouse.row][newState.GameState.focusedHouse.column].isFocused = true;
                return newState;
              }
            }
            getNextClue(newState.GameState, newState.GameTemplate);
          }
        }
        //scrollScreen(newState.GameState);

      }

      return newState;

    }
    case 'PREVIOUS_CLUE': {
      var newState = { ...state };
      getPreviousClue(newState.GameState, newState.GameTemplate);
      //scrollScreen(newState.GameState);
      return newState;
    }
    case 'NEXT_CLUE': {
      var newState = { ...state };
      getNextClue(newState.GameState, newState.GameTemplate);
      //scrollScreen(newState.GameState);
      return newState;
    }
    case 'HANDLE_BACKSPACE': {
      var newState = { ...state };
      if (newState.GameState.focusedHouse.row < 0) {
        newState.GameState.focusedHouse.row = 0;
        getPreviousClue(newState.GameState, newState.GameTemplate);
        //scrollScreen(newState.GameState);
        return newState;
      } else if (newState.GameState.focusedHouse.column < 0) {
        newState.GameState.focusedHouse.column = 0;
        getPreviousClue(newState.GameState, newState.GameTemplate);
        //scrollScreen(newState.GameState);
        return newState;
      }
      //if the focused house has any value delete it else go backwards house
      const currentCell = newState.GameState.savedGame.cache.matrix[newState.GameState.focusedHouse.row][newState.GameState.focusedHouse.column];
      if (currentCell.letra && !currentCell.revelada) {
        currentCell.letra = '';
        newState.GameState.score = scoreCrossword(newState.GameTemplate, newState.GameState.savedGame.cache.matrix);
        return newState;
      }
      //if orientation is horizontal
      if (newState.GameState.orientation === "horizontal") {
        const { x } = newState.GameTemplate.chaves.horizontal[newState.GameState.currentClueNumber][0].palavras;
        newState.GameState.houseStates[newState.GameState.focusedHouse.row][newState.GameState.focusedHouse.column].isFocused = false;
        newState.GameState.focusedHouse.column--;
        if (newState.GameState.focusedHouse.column < x) {
          getPreviousClue(newState.GameState, newState.GameTemplate);
          //scrollScreen(newState.GameState);
          return newState;
        }
        newState.GameState.houseStates[newState.GameState.focusedHouse.row][newState.GameState.focusedHouse.column].isFocused = true;
      } else {
        const { y } = newState.GameTemplate.chaves.vertical[newState.GameState.currentClueNumber][0].palavras;
        newState.GameState.houseStates[newState.GameState.focusedHouse.row][newState.GameState.focusedHouse.column].isFocused = false;
        newState.GameState.focusedHouse.row--;
        if (newState.GameState.focusedHouse.row < y) {
          getPreviousClue(newState.GameState, newState.GameTemplate);
          //scrollScreen(newState.GameState);
          return newState;
        }
        newState.GameState.houseStates[newState.GameState.focusedHouse.row][newState.GameState.focusedHouse.column].isFocused = true;
        //scrollScreen(newState.GameState);
      }

      return newState;
    }
    case 'RESET': {
      return INITIAL_STATE;
    }
    case 'SET_SCROLL_REF': {
      var newState = { ...state };
      newState.GameState.scrollElementRef = action.payload.scrollElementRef;
      newState.GameState.rowsCoords = action.payload.rowCoords;
      return newState;
    }
    case 'CHECK_GAME': {
      const newState = { ...state };
      const { GameState, GameTemplate } = newState;
      GameTemplate.matrix.forEach((row, r) => row.forEach((cell, c) => {
        const house = GameState.houseStates[r]?.[c];
        if (!house) return;
        if (!isPlayable(cell)) {
          house.isCorrect = '';
          return;
        }
        const letra = (GameState.savedGame.cache.matrix[r]?.[c]?.letra ?? '').toUpperCase();
        house.isCorrect = letra !== '' && letra === cell.letra.toUpperCase() ? 'sim' : 'nao';
      }));
      GameState.score = scoreCrossword(GameTemplate, GameState.savedGame.cache.matrix);
      GameState.finished = true;
      return newState;
    }
    case 'REVEAL_ALL_GAME': {
      const newState = { ...state };
      const { GameState, GameTemplate } = newState;
      GameState.savedGame.cache.matrix = revealCells(GameTemplate, GameState.savedGame.cache.matrix, allPlayableCells(GameTemplate));
      GameState.score = 0;
      return newState;
    }
    case 'REVEAL_LETTER': {
      const newState = { ...state };
      const { GameState, GameTemplate } = newState;
      const { row, column } = GameState.focusedHouse;
      GameState.savedGame.cache.matrix = revealCells(GameTemplate, GameState.savedGame.cache.matrix, [{ row, col: column }]);
      GameState.score = scoreCrossword(GameTemplate, GameState.savedGame.cache.matrix);
      return newState;
    }
    case 'REVEAL_WORD': {
      const newState = { ...state };
      const { GameState, GameTemplate } = newState;
      const cells = wordCells(GameTemplate, GameState.orientation, GameState.currentClueNumber);
      GameState.savedGame.cache.matrix = revealCells(GameTemplate, GameState.savedGame.cache.matrix, cells);
      GameState.score = scoreCrossword(GameTemplate, GameState.savedGame.cache.matrix);
      return newState;
    }
    case 'CLEAR_GAME': {
      const newState = { ...state };
      const { GameState, GameTemplate } = newState;
      GameState.savedGame.cache.matrix = clearLetters(GameState.savedGame.cache.matrix);
      GameState.houseStates.forEach((row) => row.forEach((house) => {
        house.isCorrect = '';
        house.scored = false;
      }));
      GameState.score = scoreCrossword(GameTemplate, GameState.savedGame.cache.matrix);
      return newState;
    }
    case 'PAUSE_GAME': {
      var newState = { ...state };

      return newState;
    }
    default:
      return state;
  }
}


